import { render } from "./UnsubscribeSuccess.vue?vue&type=template&id=8ec9f036"
import script from "./UnsubscribeSuccess.vue?vue&type=script&lang=js"
export * from "./UnsubscribeSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__